import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/search.json)
const searchIconData = {
	icon: {
		attrs: [{}],
		colorPermutations: {
			'10210410212831741': [{}],
			'11331341331': [{}],
			'12402402401': [{}],
		},
		grid: 14,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M1001.282 889.92l-211.203-211.040c49.92-72 76.322-158.080 76.322-245.6 0-239.36-193.758-433.6-433.118-433.28s-433.761 196.48-433.281 433.28c0.48 239.36 193.921 433.28 433.281 433.28 87.36 0 173.438-26.4 245.438-76.32l211.203 210.4c14.080 14.72 34.398 23.36 55.358 23.36 43.040 0 78.72-35.68 78.72-78.72 0-20.96-8.64-41.28-22.72-55.36zM433.282 708.96c-152 0-275.679-123.68-275.679-275.68s123.679-275.68 275.679-275.68c152 0 275.68 123.68 275.68 275.68s-123.68 275.68-275.68 275.68z',
		],
		tags: ['search'],
	},
	attrs: [{}],
	properties: {
		code: 60249,
		id: 221,
		name: 'search',
		order: 3039,
		prevSize: 20,
	},
	setIdx: 1,
	setId: 1,
	iconIdx: 612,
};

// Create IconBuilder from cond-ui-kit data
const SearchIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	searchIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default SearchIconBuilder;
